import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-e-resources',
  templateUrl: './e-resources.component.html',
  styleUrls: ['./e-resources.component.scss']
})
export class EResourcesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
